// result-popup.js - Clean and optimized function-based version
(function() {
  
  // Global state variables
  const isPetPixar = false;
  let selectedSize = "S"; // Default size
  let resultPopupShown = false;
  let resultImageUrl = null;
  let disableSizeButtons = false;
  // Size configurations - dynamically check orientation for three-men-portrait
  // Make this a function so it checks the flags when called, not when file loads
  function getSizeConfig() {
    const isThreeMenPortrait = window.isThreeMenPortrait || window.isTwoMenPortrait || window.isSiblingPortrait || window.useHorizontalAspect;
    
    // Log the orientation mode for debugging
    console.log('Getting size config - orientation mode:', isThreeMenPortrait ? 'HORIZONTAL/LANDSCAPE' : 'PORTRAIT');
    console.log('window.isThreeMenPortrait:', window.isThreeMenPortrait, 'window.useHorizontalAspect:', window.useHorizontalAspect);
    
    return isThreeMenPortrait ? {
    // Horizontal/landscape orientation for three-men-portrait
    S: { 
      aspectRatio: 30 / 20, // Inverted for landscape
      price: "$85", 
      dimensions: "30×20 cm", // Width × Height
      imperialDimensions: "12×8\"",
      variantId: getVariantId("S")
    },
    M: { 
      aspectRatio: 40 / 30, // Inverted for landscape (4:3)
      price: "$130", 
      dimensions: "40×30 cm", // Width × Height
      imperialDimensions: "16×12\"",
      variantId: getVariantId("M")
    },
    L: { 
      aspectRatio: 70 / 50, // Inverted for landscape
      price: "$190", 
      dimensions: "70×50 cm", // Width × Height
      imperialDimensions: "28×20\"",
      variantId: getVariantId("L")
    }
  } : {
    // Standard portrait orientation for other templates
    S: { 
      aspectRatio: 20 / 30, 
      price: "$85", 
      dimensions: "20×30 cm",
      imperialDimensions: "8×12\"",
      variantId: getVariantId("S")
    },
    M: { 
      aspectRatio: 30 / 40, 
      price: "$130", 
      dimensions: "30×40 cm",
      imperialDimensions: "12×16\"",
      variantId: getVariantId("M")
    },
    L: { 
      aspectRatio: 50 / 70, 
      price: "$190", 
      dimensions: "50×70 cm",
      imperialDimensions: "20×28\"",
      variantId: getVariantId("L")
    }
    };
  }

  /**
   * Get variant ID based on current page and size
   */
  function getVariantId(size) {
    const variantIds = {
      pet: {
        S: "54386981110108", // Shopify variant ID for size S
        M: "54386981142876", // Shopify variant ID for size M
        L: "54386981175644", // Shopify variant ID for size L
      },
      peakyBlinders: {
        S: "PEAKY_S_VARIANT_ID", // TODO: Replace with actual Shopify variant ID for Peaky Blinders size S
        M: "PEAKY_M_VARIANT_ID", // TODO: Replace with actual Shopify variant ID for Peaky Blinders size M
        L: "PEAKY_L_VARIANT_ID", // TODO: Replace with actual Shopify variant ID for Peaky Blinders size L
      },
      default: {
        S: "54224438722908", // Shopify variant ID for size S
        M: "54215893451100", // Shopify variant ID for size M
        L: "54215893483868", // Shopify variant ID for size L
      }
    };
    
    // Check for Peaky Blinders template
    if (window.isPeakyBlinders) {
      return variantIds.peakyBlinders[size];
    }
    
    return isPetPixar ? variantIds.pet[size] : variantIds.default[size];
  }

  /**
   * Add CSS styles to the document
   */
  function addStyles() {
    if (document.getElementById("result-popup-styles")) return;

    const style = document.createElement("style");
    style.id = "result-popup-styles";
    style.textContent = `
      .selected {
          background-color: #f0f5fb;
      }
      #pixar-result-revert:hover {
          background-color: #636363 !important;
      }
      @media (max-width: 769px) {
        #pixar-result-image-container {
            max-height: 50vh;
            padding: 5px;
            overflow: hidden;
        }
        #pixar-image-shadow {
            display: none;
        }
        #pixar-result-image {
            max-width: calc(100% - 10px) !important;
            max-height: calc(100% - 10px) !important;
        }
      }
      @media (max-width: 450px) {
        #final-popup {
            max-height: 700px !important;
        }
      }
      .cart-display{
        display: none;
      }
      #pixar-result-popup {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.98);
        z-index: 99999999;
        display: none;
        overflow: auto;
        padding: 20px;
        box-sizing: border-box;
        font-family: Helvetica, Arial, sans-serif;      
      }
      #pixar-cart-status {
                position: absolute;
                bottom: 10px;
                left: 0;
                right: 0;
                background: rgba(0, 0, 0, 0.7);
                color: white;
                padding: 8px;
                text-align: center;
                font-weight: bold;
                border-radius: 0 0 8px 8px;
                z-index: 10;      
      }
              .pixar-continue-button.loading,
              #pixar-result-continue.loading {
                position: relative;
                color: transparent !important;
                transition: background-color 0.3s ease;
              }
              .pixar-continue-button.loading::after,
              #pixar-result-continue.loading::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                width: 24px;
                height: 24px;
                margin: -12px 0 0 -12px;
                border-radius: 50%;
                border: 3px solid rgba(255, 255, 255, 0.8);
                border-top-color: transparent;
                animation: pixar-spinner 0.8s linear infinite;
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
              }
              @keyframes pixar-spinner {
                to {transform: rotate(360deg);}
              }
              /* Second animation for pulse effect */
              .pixar-continue-button.loading,
              #pixar-result-continue.loading {
                animation: pixar-pulse 2s infinite ease-in-out;
              }
              @keyframes pixar-pulse {
                0% { background-color: var(--original-bg, #1E316A); }
                50% { background-color: var(--pulse-bg, #152450); }
                100% { background-color: var(--original-bg, #1E316A); }
              }                
    `;

    document.head.appendChild(style);
  }

  /**
   * Create the popup HTML structure
   */
  function createPopup(imageUrl) {
    // Remove existing popup if any
    const existingPopup = document.getElementById("pixar-result-popup");
    if (existingPopup) {
      existingPopup.remove();
    }

    // Add styles
    addStyles();

    // Try to get size selector HTML from DOM or stored version
    let sizeSelectorHtml = "";
    const element = document.querySelector('.testify-variant-html');
    
    console.log('Creating popup - looking for .testify-variant-html element:', element ? 'FOUND' : 'NOT FOUND');
    console.log('window.isSizeSelector:', window.isSizeSelector);
    
    if (element) {
      // clone node to avoid modifying the original before remove()
      const clone = element.cloneNode(true);

      // remove inline display:none if present
      if (clone.style.display === "none") {
        clone.style.removeProperty("display");
      }

      sizeSelectorHtml = clone.outerHTML;
      
      // Store it globally for retry scenarios
      window.storedSizeSelectorHtml = sizeSelectorHtml;
      console.log('Stored size selector HTML for future use');

      // finally remove the element from DOM
      element.remove();
    } else if (window.storedSizeSelectorHtml && window.isSizeSelector) {
      // Use stored HTML if element not found (retry scenario)
      sizeSelectorHtml = window.storedSizeSelectorHtml;
      console.log('Using stored size selector HTML from previous popup');
    } else {
      console.log('No size selector HTML available');
    }

    // Create popup container
    const popup = document.createElement("div");
    popup.id = "pixar-result-popup";
    popup.className = "result-popup-overlay";
    
    popup.innerHTML = `
      <div id="final-popup" style="position: relative; max-width: 600px; margin: 20px auto; padding: 20px; background: white; border-radius: 12px; box-shadow: 0 0 30px rgba(0,0,0,0.1); display: flex; flex-direction: column; height: calc(100vh - 40px); max-height: 800px; font-family: Helvetica, Arial, sans-serif;">
          
          <h4 style="text-align: center; font-size: 16px; margin-top: 10px; margin-bottom: 5px; color: #000000; font-weight: bold; text-transform: uppercase; font-family: Helvetica, Arial, sans-serif;">Your preview</h4>
          <button id="close-final-image" style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 30px; padding: 5px; color: #555;">×</button>
          <div id="pixar-result-image-container" style="flex: 1; min-height: 0; margin: 0 auto 10px auto; width: 100%; position: relative; display: flex; align-items: center; justify-content: center; padding: 10px; overflow: hidden;">
            <div id="pixar-image-shadow" style="position: absolute; inset: 10px 15px 5px 50%; border-radius: 8px; background: rgb(245, 245, 245); box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 25px; z-index: 0; transform: translateX(-50%); max-height: calc(100% - 20px);"></div>
            <img id="pixar-result-image" src="${imageUrl}" alt="Processed image" style="position: relative; z-index: 1; width: auto; height: auto; max-width: calc(100% - 20px); max-height: calc(100% - 20px); display: block; object-fit: contain; transition: all 0.3s ease-in-out; border-radius: 8px; background: white;">
            <div id="pixar-result-image-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: none; z-index: 2;"></div>
          </div>

          ${ (window.isSizeSelector && sizeSelectorHtml) ? '<div class="chosesize" style="width: 95%; margin: 0 auto; padding-top: 5px; padding-bottom: 8px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: 600; color: #2c3e50; text-transform: uppercase; letter-spacing: 0.5px;">Choose Your Size</div>' : ''}
          <!-- Fixed position controls container -->
          <div style="flex-shrink: 0; margin-top: 0;">
            <div style="min-height: ${window.isSizeSelector ? '110px' : '0'}; margin-bottom: 10px;">
              ${ window.isSizeSelector ? sizeSelectorHtml : ''}
            </div>
            <div style="display: flex; justify-content: center; gap: 20px; margin-top: 10px; margin-bottom: 10px;">
              <button id="pixar-result-revert" style="background-color: #838383; color: white; padding: 12px 25px; font-size: 16px; font-weight: bold; border: none; border-radius: 8px; cursor: pointer; text-transform: uppercase; box-shadow: 0 4px 8px rgba(0,0,0,0.1); transition: background-color 0.2s ease-in-out; font-family: Helvetica, Arial, sans-serif;">GO BACK</button>
              <button id="pixar-result-continue" style="background-color: #1E316A; color: white; padding: 12px 25px; font-size: 16px; font-weight: bold; border: none; border-radius: 8px; cursor: pointer; text-transform: uppercase; box-shadow: 0 4px 8px rgba(0,0,0,0.1); transition: background-color 0.2s ease-in-out; font-family: Helvetica, Arial, sans-serif;">CONTINUE</button>
            </div>
          </div>
        </div>
    `;

    document.body.appendChild(popup);
  }

  /**
   * Select a size and update the UI
   */
  function selectSize(size) {
    if (selectedSize === size || disableSizeButtons) return;

    selectedSize = size;

    // Update UI - make sure we're selecting within the result popup
    const sizeOptions = document.querySelectorAll("#pixar-result-popup .size-option");
    sizeOptions.forEach(option => {
      const isSelected = option.dataset.size === size;
      option.classList.toggle("selected", isSelected);
      
      // Log for debugging
      if (isSelected) {
        console.log('Size selected:', size, 'Variant ID:', option.getAttribute('data-variant'));
      }
    });

    // Apply aspect ratio
    applyAspectRatio(size);
  }

/**
 * Apply aspect ratio to the result image based on the original image
 */
function applyAspectRatio(size) {
  const image = document.getElementById("pixar-result-image");
  const shadow = document.getElementById("pixar-image-shadow");

  if (!image || !resultImageUrl) return;

  const config = getSizeConfig()[size];
  if (!config) return;

  const aspectRatio = config.aspectRatio;
  const isHorizontal = window.isThreeMenPortrait || window.isTwoMenPortrait || window.isSiblingPortrait || window.useHorizontalAspect;
  console.log(`Applying aspect ratio ${aspectRatio} for size ${size} (${config.dimensions}) - ${isHorizontal ? 'HORIZONTAL' : 'PORTRAIT'} mode`);

  // Always use the original image (resultImageUrl) to prevent repeated cropping
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = resultImageUrl;

  img.onload = function () {
    let srcX = 0, srcY = 0, srcW = img.width, srcH = img.height;

    // Calculate crop area to maintain new aspect ratio
    const currentAspect = srcW / srcH;
    
    console.log(`Image dimensions: ${srcW}x${srcH}, current aspect: ${currentAspect.toFixed(3)}`);
    console.log(`Target aspect ratio: ${aspectRatio.toFixed(3)} for size ${size}`);
    console.log(`Comparison: current (${currentAspect.toFixed(3)}) vs target (${aspectRatio.toFixed(3)})`);

    if (Math.abs(currentAspect - aspectRatio) < 0.01) {
      console.log('Aspect ratios match - no cropping needed');
    } else if (currentAspect > aspectRatio) {
      // Too wide – crop sides
      const newW = srcH * aspectRatio;
      srcX = (srcW - newW) / 2;
      srcW = newW;
      console.log(`Too wide - cropping sides. New dimensions: ${srcW}x${srcH}`);
    } else if (currentAspect < aspectRatio) {
      // Too tall – crop top/bottom
      const newH = srcW / aspectRatio;
      srcY = (srcH - newH) / 2;
      srcH = newH;
      console.log(`Too tall - cropping top/bottom. New dimensions: ${srcW}x${srcH}`);
    }

    // Draw cropped image to canvas
    const canvas = document.createElement("canvas");
    canvas.width = srcW;
    canvas.height = srcH;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, srcX, srcY, srcW, srcH, 0, 0, srcW, srcH);

    // Update the displayed image (but not resultImageUrl)
    image.src = canvas.toDataURL("image/png");

    // Apply basic styles
    image.style.maxWidth = "100%";
    image.style.maxHeight = "100%";
    image.style.objectFit = "contain";
    image.style.borderRadius = "8px";

    // Adjust shadow to match immediately (no extra image load loop)
    adjustShadowToImage(image, shadow);

  };

  img.onerror = function () {
    console.error("Failed to load original image for aspect ratio adjustment");
    image.style.aspectRatio = aspectRatio.toString();
  };
}

/**
 * Adjust the shadow to match the image size
 */
function adjustShadowToImage(image, shadow) {
  if (!image || !shadow) return;
  
  // Wait for image to fully load and render
  const updateShadow = () => {
    const rect = image.getBoundingClientRect();
    const containerRect = image.parentElement.getBoundingClientRect();
    
    // Calculate position relative to container
    const leftOffset = rect.left - containerRect.left;
    const topOffset = rect.top - containerRect.top;
    
    shadow.style.width = `${rect.width}px`;
    shadow.style.height = `${rect.height}px`;
    shadow.style.left = `${leftOffset + 5}px`; // Slight offset for shadow effect
    shadow.style.top = `${topOffset + 5}px`;
    shadow.style.transform = "none";
    shadow.style.borderRadius = "8px";
  };
  
  // Try multiple times to ensure proper sizing
  setTimeout(updateShadow, 50);
  setTimeout(updateShadow, 200);
  
  // Also update when window resizes
  const resizeHandler = () => updateShadow();
  window.addEventListener('resize', resizeHandler);
  
  // Clean up resize listener when popup is closed
  const popup = document.getElementById("pixar-result-popup");
  if (popup) {
    popup.addEventListener('remove', () => {
      window.removeEventListener('resize', resizeHandler);
    });
  }
}

  /**
   * Setup all event listeners
   */
  function setupEventListeners() {
    const popup = document.getElementById("pixar-result-popup");

    // Close button
    const closeBtn = popup.querySelector("#close-final-image");
    closeBtn.addEventListener("click", closePopup);

    // Size selection
    const sizeOptions = popup.querySelectorAll(".size-option");
    sizeOptions.forEach(option => {
      option.addEventListener("click", () => {
        const size = option.dataset.size;
        const variantId = option.getAttribute('data-variant');
        console.log('Size option clicked:', size, 'Variant:', variantId);
        selectSize(size);
      });
    });

    // Go back button
    const goBackBtn = popup.querySelector("#pixar-result-revert");
    if (goBackBtn) {
      goBackBtn.addEventListener("click", goBack);
    }

    // Continue button
    const continueBtn = popup.querySelector("#pixar-result-continue");
    continueBtn.addEventListener("click", continueToCheckout);

  }

  /**
   * Display the popup
   */
  function displayPopup() {
    const popup = document.getElementById("pixar-result-popup");
    popup.style.display = "block";
    document.body.style.overflow = "hidden";

    // Update size labels for three-men-portrait template (horizontal/landscape)
    const isThreeMenPortrait = window.isThreeMenPortrait || window.isTwoMenPortrait || window.isSiblingPortrait || window.useHorizontalAspect;
    if (isThreeMenPortrait) {
      console.log('Updating size labels for three-men-portrait (horizontal orientation)');
      
      // Find all size display elements and update them
      const sizeDisplays = popup.querySelectorAll('.custom-image-size-display');
      const horizontalSizes = ["30×20 cm", "40×30 cm", "70×50 cm"];
      
      sizeDisplays.forEach((display, index) => {
        if (index < horizontalSizes.length) {
          console.log(`Updating size ${index}: ${display.textContent} -> ${horizontalSizes[index]}`);
          display.textContent = horizontalSizes[index];
        }
      });
    }

    // Ensure image displays properly with full aspect ratio
    const image = document.getElementById("pixar-result-image");
    const shadow = document.getElementById("pixar-image-shadow");
    
    if (image) {
      // Load the image and adjust the layout after it's ready
      if (image.complete) {
        adjustShadowToImage(image, shadow);
      } else {
        image.addEventListener('load', () => {
          adjustShadowToImage(image, shadow);
        });
      }
    }

    // Apply default aspect ratio if size selector is enabled
    if (window.isSizeSelector) {
      setTimeout(() => {
        applyAspectRatio(selectedSize);
      }, 100);
    }
  }

  /**
   * Close the popup
   */
  function closePopup() {
    const popup = document.getElementById("pixar-result-popup");
    if (popup) {
      popup.remove();
    }

    document.body.style.overflow = "";
    resultPopupShown = false;
    resetToOriginalState();
  }

  /**
   * Go back to previous step
   */
  function goBack() {
    closePopup();
    
    // Check if this is from three men portrait workflow
    const threeMenPopup = document.getElementById('three-men-popup');
    if (threeMenPopup && window.isThreeMenPortrait) {
      // Re-show the three men portrait popup
      threeMenPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Reset the continue button and show retry state
      const continueButton = document.getElementById('three-men-continue-button');
      if (continueButton) {
        continueButton.disabled = false;
        continueButton.textContent = 'Retry Transformation';
      }
      
      // Mark that user returned from preview
      window.threeMenReturnedFromPreview = true;
      
      // Show retry message if element exists
      const retryMessage = document.getElementById('three-men-retry-message');
      if (retryMessage) {
        retryMessage.style.display = 'block';
      }
      
      // Don't clear the flags as they're needed for template identification and size selector
      // window.isThreeMenPortrait and window.isSizeSelector should be preserved
      
      return;
    }

    // Check if this is from two men portrait workflow
    const twoMenPopup = document.getElementById('two-men-popup');
    if (twoMenPopup && window.isTwoMenPortrait) {
      // Re-show the two men portrait popup
      twoMenPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Reset the continue button and show retry state
      const continueButton = document.getElementById('two-men-continue-button');
      if (continueButton) {
        continueButton.disabled = false;
        continueButton.textContent = 'Retry Transformation';
      }
      
      // Mark that user returned from preview
      window.twoMenReturnedFromPreview = true;
      
      // Show retry message if element exists
      const retryMessage = document.getElementById('two-men-retry-message');
      if (retryMessage) {
        retryMessage.style.display = 'block';
      }
      
      // Don't clear the flags as they're needed for template identification and size selector
      // window.isTwoMenPortrait and window.isSizeSelector should be preserved
      
      return;
    }
    
    // Check if this is from sibling portrait workflow
    const siblingPopup = document.getElementById('sibling-popup');
    if (siblingPopup && window.isSiblingPortrait) {
      // Re-show the sibling portrait popup
      siblingPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Reset the continue button and show retry state
      const continueButton = document.getElementById('sibling-continue-button');
      if (continueButton) {
        continueButton.disabled = false;
        continueButton.textContent = 'Retry Transformation';
      }
      
      // Mark that user returned from preview
      window.siblingReturnedFromPreview = true;
      
      // Show retry message if element exists
      const retryMessage = document.getElementById('sibling-retry-message');
      if (retryMessage) {
        retryMessage.style.display = 'block';
      }
      
      // Don't clear the flags as they're needed for template identification and size selector
      // window.isSiblingPortrait and window.isSizeSelector should be preserved
      
      return;
    }

    // Check if this is from Peaky Blinders workflow
    const peakyBlindersPopup = document.getElementById('peaky-blinders-popup');
    if (peakyBlindersPopup && window.isPeakyBlinders) {
      // Re-show the Peaky Blinders popup
      peakyBlindersPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Reset the continue button and show retry state
      const continueButton = document.getElementById('peaky-blinders-continue-button');
      if (continueButton) {
        continueButton.disabled = false;
        continueButton.textContent = 'Retry Transformation';
      }
      
      // Set the retry flag
      window.peakyBlindersReturnedFromPreview = true;
      
      // Show the retry message
      const retryMessage = document.getElementById('peaky-blinders-retry-message');
      if (retryMessage) {
        retryMessage.style.display = 'block';
      }
      
      // Don't clear the flags as they're needed for template identification and size selector
      // window.isPeakyBlinders and window.isSizeSelector should be preserved
      
      return;
    }
    
    // Check if this is from single face swap workflow
    const singleFacePopup = document.getElementById('single-face-popup');
    if (singleFacePopup && window.isSingleFaceSwapWorkflow) {
      // Re-show the single face swap popup
      singleFacePopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Clean up workflow flag
      window.isSingleFaceSwapWorkflow = false;
      
      return;
    }
    
    // Check if this is from room-flag workflow
    const roomFlagPopup = document.getElementById('room-flag-popup');
    if (roomFlagPopup && window.roomFlagImages) {
      // Re-show the room flag popup
      roomFlagPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      
      // Show the re-upload message to guide users
      const reuploadMessage = document.getElementById('reupload-message');
      if (reuploadMessage) {
        reuploadMessage.style.display = 'block';
      }
      
      // Mark that user has returned from result
      window.roomFlagReturnedFromResult = true;
      
      // Update the upload button text if the function exists
      if (typeof window.updateUploadButtonText === 'function') {
        window.updateUploadButtonText();
      } else {
        // Try to update manually if function not in global scope
        const uploadButtonText = document.getElementById('upload-button-text');
        if (uploadButtonText && window.roomFlagImages) {
          const uploadedCount = window.roomFlagImages.filter(img => img !== null).length;
          if (uploadedCount === 4) {
            uploadButtonText.textContent = 'View/Edit Your Photos';
          }
        }
      }
      
      return;
    }
    
    // Handle other workflows
    if (window.textOverleyVisible) {
      window.showTextPopup(window.watermarkedImageUrlToShow);
    } else if (window.promptVisible) {
      window.showPromptPopup(window.selectedFile);
    } else {
      const popupOpenButton = document.getElementById("aurora-upload-button");
      popupOpenButton?.click();   
    }
  }

  /**
   * Continue to checkout
   */
  async function continueToCheckout(e) {
    e.preventDefault();
    const cartSidebar = document.querySelector('#CartPopup');
    // cartSidebar?.classList.add('cart-display');

    const btn = e.currentTarget;
    setButtonLoading(btn, true);
    showCartStatus("Adding to cart... You will be redirected shortly");
    disableSizeButtons = true;

    // Get the selected size option element from within the result popup
    const selectedOption = document.querySelector('#pixar-result-popup .size-option.selected');
    let variantId = null;
    
    if (selectedOption) {
      // Get variant ID from the data-variant attribute
      variantId = selectedOption.getAttribute('data-variant');
      console.log('Selected size:', selectedOption.dataset.size);
      console.log('Variant ID from selected option:', variantId);
    }
    

    // Fallback to default if no variant found
    if (!variantId) {
      const size = selectedSize || "S";
      variantId = getSizeConfig()[size]?.variantId;
      console.warn('Using fallback variant ID:', variantId);
    }
    const props = {};
    
    // Add transformation style metadata if available
    if (window.selectedTransformationStyle) {
      props["transformation_style"] = window.selectedTransformationStyle;
    }
    if (window.selectedTransformationStyleName) {
      props["style_name"] = window.selectedTransformationStyleName;
    }
    
    // Check if this is single face swap workflow
    if (window.isSingleFaceSwapWorkflow && window.resultImageUrl) {
        // For single face swap, still upload to S3 but don't add base64 to cart properties
        let uploadedUrl = '';
        const imageName = `${variantId}_${Date.now()}`;
        if (window?.nonWatermarkResultImg) {
            uploadedUrl = await uploadImageToS3(window?.nonWatermarkResultImg, imageName);
            if (uploadedUrl) props["_nonwatermarkimg"] = `https://letzteshemd.s3.amazonaws.com/${imageName}.png`;
        }
        // Store in localStorage for display (handled in redirectToCart)
        addToCart(variantId, props);
    } else {
        // Original flow for other products - upload to S3
        let uploadedUrl = '';
        const imageName = `${variantId}_${Date.now()}`;
        if (window?.nonWatermarkResultImg) {
            uploadedUrl = await uploadImageToS3(window?.nonWatermarkResultImg, imageName);
        } else {
            uploadedUrl = window.processedImageUrl;
        }
        if (uploadedUrl) props["_nonwatermarkimg"] = `https://letzteshemd.s3.amazonaws.com/${imageName}.png`;
        addToCart(variantId, props);
    }
  }

    // --- Helpers ---
    function setButtonLoading(btn, loading) {
      btn.disabled = loading;
      btn.classList.toggle("loading", loading);
      btn.textContent = loading ? "Adding to cart..." : "Continue";
    }

    function showCartStatus(msg) {
      const container = document.getElementById("pixar-result-image-container");
      if (!container) return;
      let status = document.getElementById("pixar-cart-status");
      if (!status) {
          status = document.createElement("div");
          status.id = "pixar-cart-status";
          status.style.cssText = `position:absolute;bottom:10px;left:0;right:0;background:rgba(0,0,0,0.7);color:#fff;padding:8px;text-align:center;font-weight:bold;border-radius:0 0 8px 8px;z-index:10;`;
          container.appendChild(status);
      }
      status.textContent = msg;
    }

    async function uploadImageToS3(base64, filename) {
      try {
          const res = await fetch(`${window.baseURL}/upload`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name: filename, base64Image: base64 })
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.error);
          return data.url;
      } catch (err) {
          console.error("S3 upload failed:", err);
          return null;
      }
    }

    function addToCart(variantId, props) {
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          if (!cart.item_count) localStorage.removeItem('cartooniqueImages');
        });
      
      // Prepare bundled sections for Impact theme
      let sectionsToBundle = ["variant-added"];
      
      // Dispatch event to collect additional sections (like cart-drawer)
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );
      
      // Prepare cart data with sections for Impact theme
      const cartData = { 
        items: [{ 
          id: String(variantId), 
          quantity: 1, 
          properties: props 
        }],
        sections: sectionsToBundle.join(","),
        sections_url: window.location.pathname
      };
      
      console.log("Adding to cart with data:", cartData);
      
      fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(cartData)
      })
          .then(r => {
            if (!r.ok) {
              return r.json().then(err => {
                console.error("Cart add error details:", err);
                throw new Error(err.description || "Failed to add to cart");
              });
            }
            return r.json();
          })
          .then(async (responseData) => {
            // Get updated cart data
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            
            // Add sections from response to cart object for Impact theme
            if (responseData.sections) {
              cart.sections = responseData.sections;
            }
            
            // Dispatch variant:add event for Impact theme with sections
            document.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: {
                items: responseData?.items || [responseData],
                cart: cart
              }
            }));
            
            // Also dispatch cart:change for broader compatibility
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: {
                baseEvent: 'variant:add',
                cart: cart
              }
            }));
            
            redirectToCart(responseData?.items[0]?.key || responseData?.key, variantId);
          })
          .catch((e) => console.error("Error adding to cart:", e));
      
    }

    function redirectToCart(key, variantId) {
      try {
          // Get stored images from localStorage
          const storedImages = JSON.parse(localStorage.getItem("cartooniqueImages")) || {};

          // For single face swap, use the global resultImageUrl or window.resultImageUrl
          let imageToStore = resultImageUrl || window.resultImageUrl || window.watermarkedImageUrlToShow || "";
          
          console.log("Storing image for cart key:", key, "Image URL length:", imageToStore.length);
          
          // Update the image for the given cart key
          storedImages[key] = imageToStore;

          // Save back to localStorage
          localStorage.setItem("cartooniqueImages", JSON.stringify(storedImages));
          
          // Trigger cart refresh to update images
          window.dispatchEvent(new CustomEvent('cart:refresh'));
          
          // Force multiple updates to ensure images are replaced
          // This handles timing issues with Impact theme's bundled sections
          const updateImages = () => {
            if (typeof window.updatecartimagestocartoonique === 'function') {
              window.updatecartimagestocartoonique();
            }
          };
          
          // Update at multiple intervals to catch different render timings
          setTimeout(updateImages, 50);
          setTimeout(updateImages, 150);
          setTimeout(updateImages, 300);
          setTimeout(updateImages, 500);
          setTimeout(updateImages, 800);
          setTimeout(updateImages, 1200);
          
          // Close the popup after successfully adding to cart
          setTimeout(() => {
            closePopup();
            console.log("Closed result popup after adding to cart");
            // Impact theme will automatically open cart drawer on variant:add event
          }, 500);
          
      } catch (error) {
          console.error("Error updating localStorage:", error);
          
          // Still close the popup on error
          setTimeout(() => {
              closePopup();
          }, 500);
      }

    };

  /**
   * Reset to original state (cleanup)
   */
  function resetToOriginalState() {
    // Reset transformed images
    const transformedImage = document.querySelector(".pixar-transformed-image");
    if (transformedImage) {
      // Restore original attributes if stored
      if (transformedImage.dataset.originalSrc) {
        const originalData = {
          src: JSON.parse(transformedImage.dataset.originalSrc),
          attributes: JSON.parse(transformedImage.dataset.originalAttributes || "{}"),
          styles: JSON.parse(transformedImage.dataset.originalStyles || "{}")
        };

        // Restore image
        Object.entries(originalData.attributes).forEach(([key, value]) => {
          transformedImage.setAttribute(key, value);
        });

        Object.entries(originalData.styles).forEach(([key, value]) => {
          transformedImage.style[key] = value;
        });

        transformedImage.src = originalData.src.src;
        if (originalData.src.srcset) {
          transformedImage.srcset = originalData.src.srcset;
        }

        transformedImage.classList.remove("pixar-transformed-image");
      }
    }

    // Reset upload button
    const uploadBtn = document.querySelector(".file-input-wrapper__popup-open-btn");
    if (uploadBtn) {
      uploadBtn.textContent = "TRANSFORM YOUR PHOTO";
      uploadBtn.style.backgroundColor = "#4a7dbd";
    }

    // Reset file input
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }

    // Clear image manager state
    if (window.imageProcessingManager) {
      window.imageProcessingManager.originalImageDataUrl = null;
      window.imageProcessingManager.croppedImageDataUrl = null;
      window.imageProcessingManager.transformationComplete = false;
      window.imageProcessingManager.stylizedImageUrl = null;
    }
  }

  /**
   * Main function to show the result popup
   */
  function showResultPopup(imageUrl) {
    // Check if we need to force recreate for three-men, two-men, or sibling retry
    const forceRecreate = window.threeMenForceRecreatePopup === true || window.twoMenForceRecreatePopup === true || window.siblingForceRecreatePopup === true;
    
    if (resultPopupShown && !forceRecreate) {
      console.log("Result popup already shown");
      return;
    }
    
    // Clear the force flag if it was set
    if (forceRecreate) {
      console.log("Force recreating popup for three-men, two-men, or sibling retry");
      window.threeMenForceRecreatePopup = false;
      window.twoMenForceRecreatePopup = false;
      window.siblingForceRecreatePopup = false;
      resultPopupShown = false; // Reset flag to allow recreation
    }

    resultImageUrl = imageUrl;
    resultPopupShown = true;
    
    
    
    createPopup(imageUrl);
    setupEventListeners();

    const selectedVariant = document.querySelector('.select span')?.textContent;
    const parsingVariantValue = selectedVariant?.split('/')?.[0]?.trim();
    const selectingVariant = document.querySelectorAll('.testify-variant-html .size-option');

    selectingVariant?.forEach(element => {
      const sizeText = element.querySelector('.custom-image-size-display')?.textContent?.trim();

      // Normalize both strings by replacing × with x
      const normalizedVariant = parsingVariantValue?.replace(/×/g, 'x');
      const normalizedSize = sizeText?.replace(/×/g, 'x');

      if (normalizedSize === normalizedVariant) {
        // Store the data-sized attribute value
        const dataSizedValue = element.getAttribute('data-sized');
        element.classList.toggle("selected", true);
        selectedSize = dataSizedValue;
      } else {
        element.classList.toggle("selected", false);
      }
    });

    displayPopup();
  }

  // Export functions to global scope
  window.showResultPopup = showResultPopup;
  window.closeResultPopup = closePopup;

})();